module.exports = __webpack_public_path__ + "media/countdown/gallery-147f2d6a.png";